var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPenIconAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_306_2542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3333 19.0724H7.33318C6.96517 19.0724 6.6665 18.7737 6.6665 18.4057C6.6665 18.0377 6.96517 17.739 7.33318 17.739H19.3333C19.7013 17.739 20 18.0377 20 18.4057C20 18.7737 19.7013 19.0724 19.3333 19.0724Z",
    fill: "#1062D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.666489 19.0724C0.491357 19.0724 0.321596 19.004 0.195293 18.8769C0.031717 18.7133 -0.0348527 18.4778 0.0175567 18.2528L0.98648 14.1416C1.01496 14.0209 1.07616 13.9105 1.16422 13.8234L13.4212 1.56647C14.1751 0.811745 15.4941 0.809955 16.2497 1.56647L17.5067 2.82332C17.8844 3.20109 18.0925 3.70338 18.0925 4.23756C18.0925 4.77191 17.8844 5.27501 17.5067 5.6518L5.24955 17.908C5.16165 17.996 5.0513 18.0574 4.93135 18.0857L0.820137 19.0546C0.768704 19.0671 0.717108 19.0724 0.666489 19.0724ZM2.24073 14.6316L1.5625 17.5097L4.44078 16.8314L16.5635 4.70876C16.6898 4.58246 16.7591 4.41546 16.7591 4.23756C16.7591 4.05983 16.6898 3.89186 16.5635 3.76653L15.3066 2.5087C15.055 2.25707 14.615 2.25707 14.3644 2.5087L2.24073 14.6316ZM4.77754 17.4369H4.78649H4.77754Z",
    fill: "#1062D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3457 8.53557C14.1752 8.53557 14.0044 8.47063 13.8747 8.33993L10.7314 5.19683C10.471 4.93641 10.471 4.51421 10.7314 4.25379C10.992 3.9932 11.4142 3.9932 11.6747 4.25379L14.8178 7.39689C15.0782 7.65731 15.0782 8.07951 14.8178 8.33993C14.6871 8.47063 14.5165 8.53557 14.3457 8.53557Z",
    fill: "#1062D0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_306_2542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenIconAccount);
export default __webpack_public_path__ + "static/media/pen-icon-account.f4d25dd5eca03033ad0fbb8c718e7abb.svg";
export { ForwardRef as ReactComponent };